export default __webpack_public_path__ + "static/media/front-b-l.09535d91.jpg";